// extracted by mini-css-extract-plugin
var _1 = "Item_author__Gb7ek";
var _2 = "Item_content__6CXrX";
var _3 = "Item_contentText__QfvTm";
var _4 = "Item_date__qxgsp";
var _5 = "Item_text__ASgDb";
var _6 = "Item_user__42XWH";
export { _1 as "author", _2 as "content", _3 as "contentText", _4 as "date", _5 as "text", _6 as "user" }
